<template>
  <b-container>
    <b-form id="printArea">
      <b-row class="my-1">
        <b-col class="text-center text-nowrap">
          <b-img alt="canary" :src="require('../assets/canary.png')" class="logoTitle mr-3"></b-img>
          <span class="logoTitle h2 pr-3">カナリアらーむ  アプリ利用設定情報</span>
        </b-col>
      </b-row>

      <b-row class="my-5">
        <b-col class="text-center">
          <table class="table-bordered keyTable">
            <tr>
              <th>所 属</th>
              <td class="text-left w-75">{{ $route.query.corporation_name || ''  }}</td>
            </tr>
            <tr>
              <th>氏 名</th>
              <td class="text-left">{{ $route.query.user_name || ''  }}<span class="ml-3">様</span></td>
            </tr>
          </table>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="lead text-center">
          <span>アプリのアカウント連携にて、下記情報を入力してください。</span>
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col class="text-center">
          <table  class="table-bordered keyTable">
            <tr>
              <th class="c-theme">メンバーID</th>
              <td class="keyValue text-monospace">{{ $route.query.app_member_id || '' }}</td>
            </tr>
            <tr>
              <th class="c-theme">シークレットキー</th>
              <td class="keyValue text-monospace">{{ $route.query.secret_key || ''  }}</td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <span>※再登録時にも必要な情報になりますので、本紙は大切に保管してください。</span>
        </b-col>
      </b-row>

      <b-row class="mt-5 mb-2">
        <b-col>
          <table class="table-bordered" style="border-color: black !important;">
            <tr>
              <td class="p-3 align-top w-75">
                <label class="caption">アプリのダウンロード</label>
                <div>
                  Androidの場合は［Google Play ストア］、iOSの場合は［App Store］にて<br>
                  「カナリアらーむ」と検索してアプリをダウンロードしてください。<br>
                  ※右のコードを読み取ることでもダウンロードページに接続できます。
                </div>
              </td>
              <td class="p-2 align-top">
                <span>Android</span><br>
                <img alt="qr-android" class="m-3" width="130" src="data:image/png;base64,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"/>
              </td>
              <td class="p-2 align-top">
                <span>iOS</span><br>
                <img alt="qr-iphone" class="m-3" width="130" src="data:image/png;base64,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"/>
              </td>
            </tr>
            <tr>
              <td class="p-3" colspan="3">
                <label class="caption">ご利用にあたって</label>
                <div>
                  アプリはメンバーID及びシークレットキーの入力をすることで、ご利用を開始することができます。<br>
                  ご利用するにあたり、アプリ起動時に表示される利用規約をご確認いただき、ご同意いただくようお願いします。<br>
                  また、お使いの端末設定や通信状況によりメッセージの取得や通知の確認が正常に行えない場合がございます。<br>
                  この点においては、お客様の責任において実施し、ご対応いただきますようお願いします。
                </div>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>

      <b-row class="buttonGroup text-center d-print-none">
        <b-col>
          <b-button id="printButton" variant="primary" @click="printPage">
            印刷する
          </b-button>
        </b-col>
      </b-row>
    </b-form>

  </b-container>
</template>

<script>
export default {
  name: 'UserId4App',
  methods: {
    printPage () {
      window.print()
    }
  }
}
</script>

<style>
.justify-content-center:has(#printArea) {
  /* puppeteer印刷時に右側が範囲外となってしまうことへの対応 */
  justify-content: normal !important;
}
</style>
<style scoped>
.logoTitle {
  font-weight: bold;
  height: 42px;
  vertical-align: middle;
}
.keyTable {
  min-width: 480px;
  display: inline-table;
}
.keyTable th,
.keyTable td {
  padding: .5em 2em;
  white-space: nowrap;
}
.keyValue {
  font-size: 1.5em;
  min-width: 12em;
}
.caption {
  padding-left: .5em;
  font-weight: bold; 
  border-left: 4px solid mediumseagreen;
}
</style>